import React, { Component } from "react";
import { Button } from "semantic-ui-react";

class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navigating: false
    };
  }
  render() {
    const { price } = this.props;

    return (
      <Button
        size="massive"
        loading={this.state.navigating}
        color="blue"
        style={{ marginBottom: "50px", marginTop: "30px" }}
        onClick={() => {
          this.setState({ navigating: true });
        }}
      >
        SCHEDULE AN APPOINTMENT {price}/clean
      </Button>
    );
  }
}

export default Calculator;
// 1b 1br =149
// 2b 1br = 169
// 3b 1br = 189
// 4b 1br = 219
// 5 —— 249
// 6 —— 279

// 1b 2br = 179
// bathroom = 30
// bedroom >3 its 25 else 20

// base 150



// WEBPACK FOOTER //
// ./src/components/calcButton.jsx